import React, { useState, useEffect } from 'react'
import { newFetch, GET } from '../../../helpers/fetch'
import { Carousel } from 'react-responsive-carousel'
import { NavLink } from "react-router-dom";
import moment from 'moment'
import placeholderBackground from '../../../assets/images/placeholder-background.png';

import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { config } from '../../../config/index'
const { SERVER_URL } = config

const EventsDetail = ({
  history,
  match: {
    params: { event_id }
  }
}) => {
  const [event, setEvent] = useState(null)

  const fetchEvent = async () => {
    let api_path = `/event/${event_id}`
    try {
      let response = await newFetch(GET, api_path)

      if (response.success) {
        setEvent(response.data)
      }  
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchEvent()
  }, [])
  return (
    <>
    <div>
        <div
          className="d-flex bg-white justify-content-between "
          style={{ padding: "1rem", background: "#3c3c3c" }}
        >
          <div className="d-flex flex-column">
            <NavLink
              to="/events"
              className="text-decoration-none"
              style={{ color: "inherit" }}
            >
              <div>
                <i className="fas fa-chevron-left pr-2"></i> Events
              </div>
            </NavLink>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center pt-4">
          <h3 className="pt-2 pl-3">{event?.title}</h3>
        </div>
      </div>
      {event && (
        <div className="d-flex flex-column">
          <div>
            {
              <Carousel showStatus={false} showThumbs={false}>
                {event.images.length > 0 ? (
                  event.images.map(image => (
                    <div style={{ height: '250px', alignContent: 'center' }} key={image.id}>
                      <img
                        style={{ maxWidth: '100%', height: '100%' }}
                        src={`${SERVER_URL}/${image.url}`}
                        alt=""
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = placeholderBackground;
                          e.target.style.height = "45%";
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <div style={{ height: '250px', alignContent: 'center' }} >
                    <img
                      src={placeholderBackground}
                      alt=""
                      style={{ height: '45%' }}
                    />
                  </div>
                )}
              </Carousel>
            }
          </div>
          <div className="container p-4">
            <h5 className="font-weight-bold">{event.title}</h5>
            <p>{event.description}</p>
            <div className="pt-2 font-weight-bold">Event Venue</div>
            <p>{event.event_venue}</p>
            <div className="pt-2 font-weight-bold">Date and Timing</div>
            <p>{moment(event.date).format('DD MMM YYYY, hh:mma')} - {moment(event.date).add(event.duration, 'hours').format('DD MMM YYYY, hh:mma')}</p>
            <div className="pt-2 font-weight-bold">Duration</div>
            <p>{event.duration} {event.duration > 1 ? 'hours' : 'hour'}</p>
            <div className="pt-2 font-weight-bold">Event URL</div>
            <a href={event.url}>{event.url}</a>
            <div className="pt-2 font-weight-bold">Contact Info</div>
            <p>{event.contact}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default EventsDetail
